module.exports = __webpack_public_path__ + "static/media/level-4.6736e4d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/floorplates/level-4.svg
// module id = 583
// module chunks = 0